import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { useState } from "react";
import { CardGrid, Image } from "../../../Styles/style";
import SectionsHeading from "../../MainComponent/SectionsHeading";
import Paragraph from "../../MainComponent/Paragraph";
import image from "../../../../assets/Images/largeeth.png";
import CustomButton from "../../MainComponent/CustomBtn";

const GridWrapper = styled(Grid)`
  display: flex;
  width: 100%;
  height: auto;
  column-gap: 20px;
  row-gap: 20px;
`;

const RowDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;
const RowGrid = styled(Grid)`
  display: flex;
  width: 100%;
  align-items: start;
  justify-content: space-between;
  /* padding: 0 10px; */
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0 10px;
  column-gap: 5px;
`;
const InputDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #333333;
  border-radius: 10px;
  padding: 5px 10px;
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: #0d0d0d;
  border-radius: 10px;
  padding: 10px;
`;
const Input = styled.input`
  background-color: transparent;
  color: #fff;
  font-family: PoppinsR;
  font-size: 16px;
  width: 100%;
  padding: 0 10px;
  box-shadow: none;
  border: none;
  :focus {
    outline: none;
  }
`;
const CoulmnDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WithdrawPage = () => {
  const [inputValue, setInputValue] = useState(0);
  const [innerSecState, setInnerSecState] = useState(0);

  const handleChange = (value) => {
    setInputValue(value);
  };

  return (
    <GridWrapper container>
      {/* ///////////////////////////////////////// */}
      <CardGrid container item xs={12} sx={{ flexWrap: "nowrap" }}>
        <RowGrid item xs={12}>
          <SectionsHeading fm="PoppinsSB" fs="16px" ta="center" color="#FC9D00">
            Withdraw ETH
          </SectionsHeading>
        </RowGrid>
        <Grid container item xs={12}>
          <RowGrid item xs={12} sm={5.7}>
            <CoulmnDiv>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Amount:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center">
                  0.1 ETH
                </Paragraph>
              </RowDiv>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Supplied For:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center">
                  1 Month
                </Paragraph>
              </RowDiv>
            </CoulmnDiv>
          </RowGrid>
          <RowGrid item xs={12} sm={5.7}>
            <CoulmnDiv>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  APY:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center">
                  1.5%
                </Paragraph>
              </RowDiv>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Yield Generated:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center">
                  0.000125 ETH
                </Paragraph>
              </RowDiv>
            </CoulmnDiv>
          </RowGrid>
        </Grid>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
      <CardGrid p="20px 10px" ai="center" jc="center" item xs={12}>
        <Grid
          item
          xs={12}
          sm={5}
          sx={{ display: "flex", rowGap: "10px", flexDirection: "column" ,width:"100%"}}
        >
          <SectionsHeading fm="PoppinsSB" fs="16px" ta="center" color="#FC9D00">
            Withdraw ETH
          </SectionsHeading>

          {innerSecState === 0 ? (
            <>
              <Paragraph fs="12px" ta="center">
                How much do you want to Wirhdraw?
              </Paragraph>
              <RowDiv>
                <Paragraph
                  p="0"
                  fs="12px"
                  ta="center"
                  fm="PoppinsB"
                  color="#707070"
                >
                  Available To Deposit:
                </Paragraph>
                <Paragraph p="0" fs="12px" ta="center" color="#707070">
                  0.1000125 ETH
                </Paragraph>
              </RowDiv>
              <InputDiv>
                <FlexDiv>
                  <Image src={image} />
                  <Input
                    value={inputValue}
                    onChange={(event) => {
                      handleChange(event.target.value);
                    }}
                  />
                </FlexDiv>
                <CustomButton
                  w="30px"
                  bgc="transparent"
                  c="#FE9C02"
                  hbgc="transparent"
                  hc="#FE9C02"
                >
                  MAX
                </CustomButton>
              </InputDiv>
            </>
          ) : innerSecState === 1 ? (
            <>
              <Paragraph fs="12px" ta="center">
                These are your transaction details. Make sure to check if this
                is correct before submitting.
              </Paragraph>
              <Div>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Amount To Withdraw:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      {inputValue}
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Remaining Balance:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      0
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
              </Div>
            </>
          ) : innerSecState === 2 ? (
            <>
              <Paragraph fs="12px" ta="center">
                These are your transaction details. Make sure to check if this
                is correct before submitting.
              </Paragraph>
              <Div>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Amount To Withdraw:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      {inputValue}
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
                <RowDiv>
                  <Paragraph
                    fs="12px"
                    ta="center"
                    fm="PoppinsB"
                    color="#707070"
                  >
                    Remaining Balance:
                  </Paragraph>
                  <FlexDiv>
                    <Image mw="20px" src={image} />
                    <Paragraph fs="14px" ta="center">
                      0
                    </Paragraph>
                  </FlexDiv>
                </RowDiv>
              </Div>
            </>
          ) : (
            <>
              <Paragraph fs="12px" ta="center">
                Your action has been successfully executed
              </Paragraph>
              <Div>
                <CoulmnDiv>
                  <Image mw="60px" src={image} />
                  <Paragraph
                    fs="12px"
                    fm="PoppinsB"
                    ta="center"
                    color="#9CFF1A"
                  >
                    0.1000125 ETH Token Withdraw Successfully
                  </Paragraph>
                </CoulmnDiv>
              </Div>
            </>
          )}

          <RowDiv>
            <CustomButton
              onClick={() => {
                setInnerSecState(innerSecState + 1);
              }}
              bgc="#FE9C02"
              c="#000"
              hbgc="#000"
              hc="#FE9C02"
            >
              {innerSecState === 0
                ? "Continue"
                : innerSecState === 1
                ? "Approve"
                : innerSecState === 2
                ? "Withdraw"
                : "Dashboard"}
            </CustomButton>
            <Paragraph
              p="0"
              fs="12px"
              ta="center"
              fm="PoppinsB"
              color="#707070"
            >
              {innerSecState === 0
                ? "0/3"
                : innerSecState === 1
                ? "1/3"
                : innerSecState === 2
                ? "2/3"
                : "3/3"}
            </Paragraph>
          </RowDiv>
        </Grid>
      </CardGrid>
      {/* ///////////////////////////////////////// */}
    </GridWrapper>
  );
};

export default WithdrawPage;
